<div class="messages" #messageList (scroll)="onScroll()"
  role="log" aria-live="polite" aria-relevant="additions" [attr.aria-label]="label"
  [attr.aria-busy]="loading || loadingOlder ? 'true' : null" tabindex="0">
  <div class="load-older" *ngIf="hasMore">
    <button type="button" class="link" (click)="requestOlder()" [disabled]="loadingOlder">
      {{ loadingOlder ? 'Loading…' : 'Load earlier messages' }}
    </button>
  </div>

  <div class="thread-state" *ngIf="loading && !messages.length">
    <div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Loading</span></div>
  </div>

  <div class="thread-state empty" *ngIf="!loading && !messages.length && !pending.length">
    <p>{{ emptyText }}</p>
  </div>

  <ng-container *ngFor="let m of messages; let i = index; trackBy: trackById">
    <div class="day-divider" *ngIf="i === 0 || !isSameDay(m.created_on, messages[i - 1].created_on)">
      <span>{{ m.created_on | date:'EEEE, MMM d' }}</span>
    </div>
    <div class="bubble-row" [class.outgoing]="isOutgoing(m)">
      <div class="bubble" [class.failed]="m.status === 'FAILED'">
        <div class="sender" *ngIf="senderLabel(m) as name">{{ name }}</div>
        <div class="template-tag" *ngIf="m.template_name"><i class="bi bi-file-earmark-text" aria-hidden="true"></i> Template</div>
        <div class="content">{{ m.content }}</div>
        <div class="meta">
          <i class="bi bi-whatsapp" *ngIf="showDelivery && m.channel === 'WHATSAPP'" title="WhatsApp" aria-label="WhatsApp"></i>
          {{ m.created_on | date:'shortTime' }}
          <i class="bi tick" *ngIf="showDelivery && isOutgoing(m) && m.channel === 'WHATSAPP'" [ngClass]="statusIcon(m)"
            [title]="m.status === 'FAILED' ? (m.error_message || 'Not delivered') : (m.status | titlecase)"
            [attr.aria-label]="m.status | titlecase"></i>
        </div>
        <div class="error" *ngIf="m.status === 'FAILED'">{{ m.error_message || 'Not delivered on WhatsApp' }}</div>
      </div>
    </div>
  </ng-container>

  <div class="bubble-row outgoing" *ngFor="let p of pending; trackBy: trackPending">
    <div class="bubble pending" [class.failed]="p.status === 'FAILED'">
      <div class="content">{{ p.content }}</div>
      <div class="meta">
        <ng-container *ngIf="p.status === 'PENDING'"><i class="bi bi-clock" aria-hidden="true"></i> Sending…</ng-container>
        <ng-container *ngIf="p.status === 'FAILED'">
          <i class="bi bi-exclamation-circle" aria-hidden="true"></i> Not sent
        </ng-container>
      </div>
      <div class="error" *ngIf="p.status === 'FAILED'">
        <span>{{ p.error }}</span>
        <span class="pending-actions">
          <button type="button" class="link" (click)="retry(p)">Retry</button>
          <button type="button" class="link" (click)="discard(p)">Discard</button>
        </span>
      </div>
    </div>
  </div>
</div>

<button type="button" class="new-pill" *ngIf="newCount > 0" (click)="jumpToLatest()">
  <i class="bi bi-arrow-down" aria-hidden="true"></i>
  {{ newCount }} new {{ newCount === 1 ? 'message' : 'messages' }}
</button>

<ng-content select="[chatAboveComposer]"></ng-content>

<form class="composer" *ngIf="canReply && showComposer" (ngSubmit)="submit()">
  <ng-content select="[chatComposerStart]"></ng-content>
  <textarea #composerInput name="draft" rows="1" aria-label="Message" [placeholder]="placeholder"
    [(ngModel)]="draft" (keydown)="onKeydown($event)" maxlength="4000" enterkeyhint="enter"></textarea>
  <button type="submit" class="send-btn" [disabled]="!draft.trim()" aria-label="Send">
    <i class="bi bi-send-fill" aria-hidden="true"></i>
  </button>
</form>
